export function readJsonLocal(key) {
    if (typeof window === 'undefined' || !window.localStorage || !key) {
        return null;
    }
    try {
        const raw = window.localStorage.getItem(key);
        if (raw == null || raw === '') {
            return null;
        }
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function writeJsonLocal(key, value) {
    if (typeof window === 'undefined' || !window.localStorage || !key) {
        return;
    }
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
        /* ignore quota / private mode */
    }
}

export function removeLocalKey(key) {
    if (typeof window === 'undefined' || !window.localStorage || !key) {
        return;
    }
    try {
        window.localStorage.removeItem(key);
    } catch {
        /* ignore */
    }
}
